window.addEventListener('load', () => {
  const localizationForms = document.querySelectorAll('[data-localization_form]');
  if (!localizationForms || !localizationForms.length) return;
  localizationForms.forEach(initLocalizationForm);
});

function initLocalizationForm(form) {
  const valueList = form.querySelector('[data-value_list]');
  if (!valueList) return;
  const valueInput = form.querySelector(`input[name='${form.dataset.localization_form}_code']`);
  if (!valueInput) return;
  if (valueList.dataset.type === 'click') {
    const valueOptions = valueList.querySelectorAll('[data-value]');
    valueOptions.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        if (this.dataset.hasOwnProperty('selected')) return;
        valueInput.value = this.dataset.value;
        form.submit();
      });
    });
  } else {
    valueList.addEventListener('change', function (event) {
      valueInput.value = this.value;
      form.submit();
    });
  }
}
